
import React from 'react';
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { EventFilterOptions, EVENT_TYPES } from '@/types/event';
import { Search, Zap, Plane, MapPin, Calendar } from 'lucide-react';

interface EventFiltersProps {
  filterOptions: EventFilterOptions;
  updateFilters: (filters: Partial<EventFilterOptions>) => void;
  locations: string[];
}

const EventFilters: React.FC<EventFiltersProps> = ({ 
  filterOptions, 
  updateFilters,
  locations 
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFilters({ searchTerm: e.target.value });
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="relative flex-grow">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        <Input 
          placeholder="Rechercher un événement..." 
          value={filterOptions.searchTerm}
          onChange={handleSearchChange}
          className="pl-10"
        />
      </div>
      
      <div className="flex gap-4">
        <Select 
          value={filterOptions.eventType} 
          onValueChange={(value) => updateFilters({ eventType: value })}
        >
          <SelectTrigger className="w-[180px]">
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les types</SelectItem>
            {Object.values(EVENT_TYPES).map((type) => {
              const IconComponent = type.icon === 'Zap' ? Zap : type.icon === 'Plane' ? Plane : type.icon === 'MapPin' ? MapPin : Calendar;
              return (
                <SelectItem key={type.id} value={type.id}>
                  <div className="flex items-center gap-2">
                    <IconComponent className="h-4 w-4" style={{ color: type.color }} />
                    <span>{type.label}</span>
                  </div>
                </SelectItem>
              );
            })}
          </SelectContent>
        </Select>
        
        <Select 
          value={filterOptions.status} 
          onValueChange={(value) => updateFilters({ status: value })}
        >
          <SelectTrigger className="w-[160px]">
            <SelectValue placeholder="Statut" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les statuts</SelectItem>
            <SelectItem value="upcoming">À venir</SelectItem>
            <SelectItem value="ongoing">En cours</SelectItem>
            <SelectItem value="past">Passé</SelectItem>
          </SelectContent>
        </Select>
        
        <Select 
          value={filterOptions.location} 
          onValueChange={(value) => updateFilters({ location: value })}
        >
          <SelectTrigger className="w-[160px]">
            <SelectValue placeholder="Lieu" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les lieux</SelectItem>
            {locations.map((location) => (
              <SelectItem key={location} value={location}>{location}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default EventFilters;
